<template>
 <el-row class="main_file">
   <el-col :span="5" style="background-color: white;">
     <!-- <list :list="treeList"></list> -->
     <!-- <el-tree :data="treeList":props="defaultProps"  ></el-tree> -->
      <div class="tree over_con" style="height: calc(100vh - 100px); overflow-y: auto;overflow-x: hidden;" id="tree">
         <el-tree class="filter-tree" :data="treeList"  :indent=0 :props="defaultProps"  accordion
         highlight-current='true'
                   :filter-node-method="filterNode" ref="tree" @node-click="handleNodeClick" >
                   <!-- <template #default="{ node, treeList }"  >
                     <span class="custom-tree-node">
                       <el-row  v-if="node.level==1" :style="{width:width}" >
                         <el-col  v-if="node.data.file==null" :span="23"  style="background-color: rgb(0, 0, 128); color: white;text-align: left;padding: 0.3125rem;">
                           <span class="tree_con  over_con">{{node.label}}</span>
                           </el-npmcol>
                         <el-col :span="23" v-else><span class="tree_con"> {{node.label}}</span></el-col>
                       </el-row>
                       <el-row  v-else :style="{width:width}" >
                         <el-col  v-if="node.data.file==null" :span="23"  style="background-color: rgb(31, 96, 169); color: white;text-align: left;padding: 0.3125rem;"><span class="tree_con over_con ">{{node.label}}</span></el-col>
                         <el-col :span="23" v-else><span class="tree_con over_con">{{node.label}}</span></el-col>
                       </el-row>
                     </span>
                   </template> -->
                   <template #default="{ node, treeList }"  >
                     <span class="custom-tree-node">
                       <el-row  v-if="node.level==1" :style="{width:width}" >
                         <el-col  v-if="node.data.file==null" :span="23"  style="background-color: rgb(8,53, 113); color: white;text-align: left;padding: 0.3125rem;">
                           <!-- <el-tooltip class="item" effect="light" :disabled="isShowTooltip" :content="node.label" placement="top-start"  popper-class="tool-tip" >
                                 <span class="tree_con  over_con">{{node.label}}</span>
                               </el-tooltip> -->
                               <texttooltip
                                  :content="node.label"
                               ></texttooltip>
                           </el-col>
                         <el-col :span="23" v-else>
                           <texttooltip
                              :content="node.label"
                           ></texttooltip>
                         </el-col>
                       </el-row>
                       <el-row  v-else :style="{width:width}" >
                         <el-col  v-if="node.data.file==null" :span="23"  style="background-color: rgb(31, 96, 169); color: white;text-align: left;padding: 0.3125rem;">
                          <texttooltip
                             :content="node.label"
                          ></texttooltip>
                              </el-col>
                         <el-col :span="23" v-else>
                           <texttooltip
                              :content="node.label"
                           ></texttooltip>
                         </el-col>
                       </el-row>
                     </span>
                   </template>
                 </el-tree>
      </div>
      <el-row><el-input placeholder="请输入内容"v-model="filterText"clearable></el-input></el-row>
      <el-row style="text-align: center;">
        <el-col :span="7" style="background-color: #d6d6d6;cursor: pointer; height: 1.875rem; display: flex;justify-content: center;align-items: center;">
          <span  @click="type_bottem('Search')">清空</span>
        </el-col>
        <el-col :span="7" :offset="1"  style="background-color: #d6d6d6;cursor: pointer;height: 1.875rem; display: flex;justify-content: center;align-items: center;">
          <span @click="type_bottem('Home')">主页</span>
        </el-col>
        <el-col :span="7"  :offset="1"  style="background-color: #d6d6d6;cursor: pointer;height: 1.875rem; display: flex;justify-content: center;align-items: center;">
          <span @click="type_bottem('Back')">旧版</span>
        </el-col>
      </el-row>
   </el-col>
   <el-col :span="19" style="background-color: rgb(31, 96, 169);">
     <el-row style="background-color: rgb(31, 96, 169);; height: calc(100vh - 10px);display: flex;justify-content: center;align-items: center;" v-if="con_img=='true'">
       <!-- <img src="../../../assets/file_conten.jpg" style="width: 50%;" /> -->
       <el-image :src="require('@/assets/file_conten.png')" style="width: 60%;"></el-image>
     </el-row>
     <div class="pdf_div" v-else >
       <div class="player-div">
         <button style="color: white;text-align: center;"> {{file.info.name}}</button>
        <!-- <button @click="support('support')" style="cursor: pointer;color: white;" v-if="file.info.support=='1'">已赞</button>
         <button @click="support('support')" style="cursor: pointer;color: white;" v-else>点赞</button>
         <button @click="support('collect')" style="cursor: pointer;color: white;" v-if="file.info.collect=='1'">已收藏</button>
         <button @click="support('collect')" style="cursor: pointer;color: white;" v-else>收藏</button> -->
         <button @click="file_video()" style="cursor: pointer;color: white;" v-if=" file.info.video != '' &&  file.info.video != '0'">讲解视频</button>
         <button v-if="file.info.file_link !='0'" style="cursor: pointer;color: white;">
           <span @click="chaolianjie(file.info.file_link)">附加文档</span>[<span @click="copy_file_url(file.info.file_link)">复制</span>]
         </button>
       </div>
       <div class="whole"  v-if="file.info.type=='pdf'"  >
         <div style="margin: 15px 0; text-align: right;">
           <el-button type="primary" size="small" @click.stop="clock">
              旋转
            </el-button>
           <el-button type="primary" size="small" @click="scaleD">
              放大
            </el-button>
            <el-button type="primary" size="small" @click="scaleX">
              缩小
           </el-button>
           <el-button type="primary" size="small" @click.stop="pdf_previousPage">
              上一页
            </el-button>
            <el-button type="primary" size="small" @click.stop="pdf_nextPage">
            下一页
           </el-button>
           <span style="color: white;">当前第{{file.pdfPage}}页 / 共{{file.pageCount}}页</span>
         </div>
         <!-- <div :style="{height:height}" class="over" > -->
         <div :style="{height:height}"  class="over con" id="pdf">
          <pdf
            ref="wrapper"
            :src="file.url"
            :page="file.pdfPage"
            :rotate="pageRotate"
            @num-pages="file.pageCount = $event"
            @page-loaded="file.pdfPage = $event"
         ></pdf>
         </div>
       </div>
       <div class="whole" v-if="file.info.type=='html'" >
          <iframe v-if="show_html" :src="file.url" frameborder="0"style="width:100%;height: calc(100vh);"></iframe>
       </div>
     </div>
   </el-col>
 </el-row>
</template>

<script>
  import pdf from 'vue-pdf';
  import texttooltip from '../../../components/index/public/text-tooltip.vue';
  export default {
     watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },

    data() {
      return {
        pageRotate:0,
       con_img:'true',
        show_html:false,
        filterText: '',
        treeList:[],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        play:{
          info:{},
          status:false,
        },
        trigger:false,
        file:{
          scale:100,
          info:{},
          pdfPage : 1,
          pageCount: 0,
          num:this.$route.query.num,
        },
        height:'',
        width:'',

      }
    },
    components: {
      pdf:pdf,
      texttooltip:texttooltip
    },
    mounted: function () {
        this.get_info();
        if(this.file.num!='0'){
          this.get_pdf_data(this.file.num)
        }
      this.change_height()

    },
    methods: {
       clock() {
            this.pageRotate += 90;
             console.log(this.pageRotate)
       },
      copy_file_url(data){
        let oInput = document.createElement('input');
        //赋值给文本框
        oInput.value = data;
        document.body.appendChild(oInput);
        // 选择对象;
        oInput.select();
        // 执行浏览器复制命令
        document.execCommand("Copy");
        //复制完成删除掉输入框
        oInput.remove()
        this.$message.success("复制成功");
      },
      scaleD() {
        this.file.scale += 5;
        this.$refs.wrapper.$el.style.width = parseInt(this.file.scale) + "%";
      },
      //缩小
      scaleX() {
        this.file.scale += -5;
        this.$refs.wrapper.$el.style.width = parseInt(this.file.scale) + "%";
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      type_bottem(type){
        if(type=='Home'){
          this.$router.push('/filetow?num=0')
        }else if(type=='Back'){
          this.$router.push('/file')
        }else{
          this.filterText=''
        }
      },


      //初始化
       get_info() {
      let _this = this;
      _this.axios
        .get("/v2/user_resource/get_file_type")
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.treeList=res.data.data
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
    },

      filterNode(value, data) {
        if (!value) return true
        return data.name.indexOf(value) !== -1
      },

     handleNodeClick(data) {
      if(data.hasOwnProperty('file')){
       // this.$router.push({path:'/FileQCregister',query:{num:data.file}})

       this.file.num=data.file
       this.get_pdf_data(data.file)
       this.$router.push(`${this.$route.path}?num=${this.file.num}`)
      }
    },


    file_video(){
        window.open('/file_video?num='+this.file.num,'_blank')
      },
      pdf_previousPage(){
        var p = this.file.pdfPage
        p = p>1?p-1:this.file.pageCount
        this.file.pdfPage = p
        window.scrollTo(0, 0);
        document.getElementById('pdf').scrollTop = 0;
      },
      pdf_nextPage(){
        var p = this.file.pdfPage
        p = p<this.file.pageCount?p+1:1
        this.file.pdfPage = p
        window.scrollTo(0, 0);
        document.getElementById('pdf').scrollTop = 0;
      },
      support(opration){
        let _this=this
        _this.axios.post('/v2/user_resource/resource_support',{data:{resource_type:'file',type:'1',num:_this.file.num,opration:opration}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              if(opration=='support'){
                _this.file.info.support=res.data.data
              }else{
                _this.file.info.collect=res.data.data
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      change_height(){
        let _this=this
        _this.height=document.documentElement.clientHeight - 100+ 'px'
        var o = document.getElementById("tree");
        var width= o.clientWidth||o.offsetWidth;
         _this.width=width - 20 + 'px'
      },

      get_pdf_data(num) {
        let _this=this
        _this.file.url=''
        _this.show_html=false
        _this.axios.get('/v2/user_resource/get_file_info',{params:{file:num, type:'study'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.con_img=false
              _this.file.info=res.data.data
              if(res.data.data.type=='pdf'){
                _this.file.url=pdf.createLoadingTask('/v2/user_resource/file_watch?key='+localStorage.authorization)
                _this.file.pdfPage=1
              }else{
                _this.show_html=true
                _this.file.url='/v2/user_resource/file_watch?key='+localStorage.authorization
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      file_watch(re){
        this.file.url = pdf.createLoadingTask(re)
      },

      handle(row) { },
    //滚动到顶部
    top(){
      if (this.trigger) return;
        var curTop = document.documentElement.scrollTop || document.body.scrollTop
        var each = curTop / 2000
        var timer = setInterval(function () {
            this.trigger = true
            curTop -= each
            each += 5
            if (curTop <= 0) {
                clearInterval(timer)
                trigger = false
            }
            window.scrollTo(0, curTop)
        }, 10)
    },
    //添加笔记
    onSubmit(){},
    //超链接点击跳转
    chaolianjie(url){
      this.$message.warning('若未自动打开，可自行复制链接后在浏览器中打开观看！！')
      window.open(url,"_blank")
    }
    }}

</script>

<style scoped >
  .over_con{
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  div::-webkit-scrollbar {
      width: 6px;
    }
    div::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      opacity: 0.2;
      background: fade(@primary-color, 60%);
    }
    div::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(32, 32, 131, 0.1);
      border-radius: 0;
      background: fade(@primary-color, 30%);
    }


 /* .tree_con{
    text-align: left;  width: 100% !important;float: left !important;overflow: hidden !important;text-overflow: ellipsis !important;white-space: normal !important;
  } */
  >>>.el-tree-node__content {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      height: 2.5rem;
      cursor: pointer;

  }
   .pdf-preview canvas {
      height: 100% !important;
    }
     .pdf-preview {
        height: 100%;
      }
/*  .tree-container /deep/ .el-tree > .el-tree-node:after {
    border-top: none;
  }

    .tree /deep/ .el-tree-node {
      position: relative;

    }
 */

  .main_file {
    height: calc(100vh);
    overflow: hidden;
    background-color: white;
  }

  h1 {
    margin: 20px;
  }

  .filetree {
    width: 90%;
    margin: 0 5%;
  }
  .el-input{
    margin: 10px 0;
  }
  .over{
      overflow: auto;
    }
    .resize {
        cursor: col-resize;
        float: left;
        position: relative;
        background-color: #d6d6d6;
        border-radius: 5px;
        margin-top: 25rem;
        width: 10px;
        height: 50px;
        background-size: cover;
        background-position: center;
        /*z-index: 99999;*/
        font-size: 32px;
        color: white;
    }
    /*拖拽区鼠标悬停样式*/
    .resize:hover {
        color: #444444;
    }

  .all{
    min-height: calc(100vh - 180px);
    padding: 20px;
    margin: 10px;
    z-index: 100;
    background-color: white;
    overflow: hidden;
  }
  .video_div{
    width: 100%;
    height: 100%;
    margin: 1% 0px;
    overflow: hidden;
  }
  .video_left{
    background-color: #000000;
    width: calc(32% - 10px); /*左侧初始化宽度*/
    height: 100%;
    float: left;
  }
  .video_right{
    background-color: #000066;
    float: left;
    width: 68%;   /*右侧初始化宽度*/
    height: 100%;
  }
  .con{
    /* margin-top: 1.5rem; */
    display: flex;
    justify-content: center;
  }
  .player-div{
     width: 100%;
      height: 40px;
     background-color: rgb(80, 79, 77);
  }
    .player-div button{
        height: 100%;
        background-color: rgb(80, 79, 77);
        border: none;
        margin-left: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/index/File/File-tow.vue